module.exports = __webpack_public_path__ + "static/media/work-8.37e53c3e.jpg";